import { HTTP } from '@/http/http-client';
import { mapParams } from '@/utils/mapParams';

const getReceipts = ({ parentId, options }) =>
    HTTP.get(`schools/slug/parents/${parentId}/receipts?${mapParams({ ...options })}`).then(({ data }) => data);

const getInvoiceForNewPaymentFlow = (schoolId, parentId, paramsString) => {
    const url = `billing/invoices/${schoolId}/parents/${parentId}/v2${paramsString}`;
    return HTTP.get(url).then(({ data }) => data);
};

const downloadReceipt = ({ parentId, options }) =>
    HTTP.get(`schools/slug/parents/${parentId}/receipts/invoice-pdf?${mapParams({ ...options })}`).then(({ data }) => data);

export default {
    getReceipts,
    downloadReceipt,
    getInvoiceForNewPaymentFlow
};


// WEBPACK FOOTER //
// ./src/http/services/receiptsService.js